import { DB_NAME, DB_STORE_NAME } from "@constants";

const DB_VERSION = 1;

export const indexDB = {
  open: (): Promise<IDBDatabase> => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);
      request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains(DB_STORE_NAME)) {
          db.createObjectStore(DB_STORE_NAME);
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  },

  set: async <T>(key: string, value: T): Promise<void> => {
    const db = await indexDB.open();
    const tx = db.transaction(DB_STORE_NAME, "readwrite");
    const store = tx.objectStore(DB_STORE_NAME);
    const serialized = JSON.stringify(value);
    store.put(serialized, key);
    return new Promise((resolve, reject) => {
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  },

  get: async <T>(key: string): Promise<T | null> => {
    const db = await indexDB.open();
    const tx = db.transaction(DB_STORE_NAME, "readonly");
    const store = tx.objectStore(DB_STORE_NAME);
    return new Promise((resolve, reject) => {
      const req = store.get(key);
      req.onsuccess = () => {
        const result = req.result;
        if (result === undefined || result === null) {
          resolve(null);
        } else {
          try {
            const parsed = JSON.parse(result) as T;
            resolve(parsed);
          } catch (_error) {
            resolve(null);
          }
        }
      };
      req.onerror = () => reject(req.error);
    });
  },

  remove: async (key: string): Promise<void> => {
    const db = await indexDB.open();
    const tx = db.transaction(DB_STORE_NAME, "readwrite");
    const store = tx.objectStore(DB_STORE_NAME);
    store.delete(key);
    return new Promise((resolve, reject) => {
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  },

  clear: async (): Promise<void> => {
    const db = await indexDB.open();
    const tx = db.transaction(DB_STORE_NAME, "readwrite");
    const store = tx.objectStore(DB_STORE_NAME);
    store.clear();
    return new Promise((resolve, reject) => {
      tx.oncomplete = () => {
        db.close();
        resolve();
      };
      tx.onerror = () => {
        db.close();
        reject(tx.error);
      };
    });
  },
};
